jQuery(document).ready(function($) {

    const $body = $('body')
    const $modalCatalogTrigger = $('.js-modal-catalog-trigger');
    const $modalCatalog = $('.js-modal-catalog');
    const $datePickers = $('.datepicker');
    const $timePickers = $('.js-timepicker');
    const $timeSlotsPickers = $('.js-timeslotspicker');
    const userFilter = {
        locationId : '', // restaurant
        deliveryType : '', // delivery/pickup
        day : '', // used to filter catalog, must be the same as term slug
        week : '', // used to filter catalog
        date : '', // delivery/pickup date
        time: '', // pickup time
        timeSlot: '', // delivery timeslot
        productType: '' // meals or menu
    }

    datePickersInit($, $datePickers, userFilter);
    mealsWarningInit($, $body, userFilter);
    catalogFiltersInit($, userFilter, $datePickers);
    modalScreensInit($);
    modalCatalogInit($, $body, $modalCatalogTrigger, $modalCatalog, userFilter);
    ctaDeliveryChoicesInit($, userFilter);
    setLocationInit($, userFilter);
    timeSlotsPickersInit($, userFilter, $timeSlotsPickers);
    timePickersInit($, userFilter, $timePickers);

});


/**
 * Set location cat in cookie on postcode form submit
 * @param {jQuery} $ 
 * @param {Object} userFilter 
 */
function setLocationInit($, userFilter) {

    const $form = $('.js-set-location');
    if (!$form.length)
        return;
    const $submit = $form.find('[type="submit"]');
    const $postcode = $form.find('.postcode');
    let req = null;

    if (localizedData.postcode) {
        $postcode.val(localizedData.postcode);
    }

    $submit.on('click', function(e) {
        
        e.preventDefault();
        if (req != null) req.abort();

        $form.find('[class^=notice]').removeClass('active');
        const postcode = $postcode.val();
        if ( $submit.hasClass('js-postcode-step-validate') ) {
            $('.js-postcode-disabled').removeClass('active');
        }

        req = $.ajax({
            url: localizedData.adminUrl,
            type: "POST",
            cache: false,
            data: {
                action: 'callback_set_user_postcode',
                postcode: postcode,
                productType: userFilter.productType
            },
            success: function(res) {
                if ( res.success == true )  {
                    if (res.data.is_in_zone == true) {
                        userFilter.locationId = res.data.location_id;
                        setCookieKeys( data = userFilter );
                        $form.find('.notice-success').addClass('active');
                        if ( $submit.hasClass('js-postcode-step-validate') ) {
                            $('.js-postcode-disabled').addClass('active');
                        }
                    }
                    else {
                        $form.find('.notice-not-available').addClass('active');
                    }
                }
                else {
                    console.log(res.data);
                    $form.find('.notice-failure').addClass('active');
                }
            }
        });
    });

}


/**
 * Remove unavailable time slots from timepicker select
 * @param {jQuery} $ 
 * @param {Object} $timeSlotsPickers timeSlotsPickers jQuery object
 */
function timeSlotsPickersInit($, userFilter, $timeSlotsPickers) {
    const cookieString = getCookie( 'user-filter' );
    if ( cookieString && $timeSlotsPickers.length ) {
        const cookieObj = JSON.parse(cookieString);
        setAvailableTimeSlots($, userFilter, $timeSlotsPickers, cookieObj.date, cookieObj.timeSlot);
    }
}

/**
 * Remove unavailable hour/minutes from timepicker select
 * @param {jQuery} $ 
 * @param {Object} $timePickers timepickers jQuery object
 */
function timePickersInit($, userFilter, $timePickers) {
    const cookieString = getCookie( 'user-filter' );
    if ( cookieString && $timePickers.length ) {
        const cookieObj = JSON.parse(cookieString);
        setAvailableTime($, userFilter, $timePickers, cookieObj.date, cookieObj.time);
    }
}

/**
 * Load datepickers, select day in cookie or first day
 * @param {jQuery} $ 
 * @param {Object} $datePickers datePickers jQuery object
 * @param {Object} userFilter
 */
function datePickersInit($, $datePickers, userFilter) {

    const natDays = [
        [1, 26, 'au'], [2, 6, 'nz'], [3, 17, 'ie'],
        [4, 27, 'za'], [5, 25, 'ar'], [6, 6, 'se'],
        [7, 4, 'us'], [8, 17, 'id'], [9, 7, 'br'],
        [10, 1, 'cn'], [11, 22, 'lb'], [12, 12, 'ke']
    ];

    $datePickers.each(function() {
        
        const $datePicker = $(this);
        const minDate = $datePicker.data('min');
        const cookieString = getCookie( 'user-filter' );
        let cookieObj = {};

        $datePicker.datepicker({
            beforeShowDay: filterDates, // disable weekends and holidays
            minDate: minDate ? minDate : 0,
            maxDate: "+2W -1D" // limit to this week and the following minus monday
        });
        
        if ( isCurrentAvailable() ) {
            if ( cookieString ){
                cookieObj = JSON.parse(cookieString);
                $datePicker.datepicker("setDate", new Date(cookieObj.date));
            }
            else { 
                setDeliveryDate(userFilter, new Date());                            
                $datePicker.datepicker("setDate",new Date());
            }
        }

    });

    function filterDates(date) {
    
        const noWeekend = $.datepicker.noWeekends(date);

        if (noWeekend[0]) {
            return nationalDays(date);
        }
        else {
            return noWeekend;
        }
    
    }

    function isCurrentAvailable() {
        // check if not weekend or natDay
        return true;
    }

    function nationalDays(date) {

        for (i = 0; i < natDays.length; i++) {
            if (date.getMonth() == natDays[i][0] - 1
                && date.getDate() == natDays[i][1]) {
                return [false, natDays[i][2] + '_day'];
            }
        }
        return [true, ''];
    }
    
}


/**
 * Display modal if user tries to order a meal for today
 * @param {jQuery} $ 
 * @param {Object} $body 
 */
function mealsWarningInit($, $body, userFilter) {

    const $mealsWarning = $('.js-meals-warning');
    const $mealsWarningModal = $('.js-modal-warning-meals')
    const $modalWarningMealsTrigger = $('.js-modal-warning-meals-trigger');
    const $submit = $mealsWarningModal.find('.js-submit');

    $modalWarningMealsTrigger.on('click', function(e) {
        $body.toggleClass('modal-warning-meals-active');
    });

    $mealsWarning.on('click', function(e) {

        const cookieString = getCookie( 'user-filter' );
        let cookieObj = {};

        if ( !cookieString )
            return;

        cookieObj = JSON.parse(cookieString);

        if ( cookieObj.deliveryType && cookieObj.deliveryType == 'pickup' ) {
            e.preventDefault();
            $body.addClass('modal-warning-meals-active modal-warning-meals-pickup');
        }
        if ( cookieObj.deliveryType && moment(cookieObj.date).isSame(moment(), 'day') ) {
            e.preventDefault();
            $body.addClass('modal-warning-meals-active modal-warning-date');
        }

    });

    $submit.on('click', function(e) {
        e.preventDefault();

        const $datePicker = $(this).parent().find('.datepicker');
        let userFilterDate = $datePicker.datepicker('getDate');
        setDeliveryDate(userFilter, userFilterDate);
   
        userFilter.deliveryType = 'delivery';
        setCookieKeys( userFilter );
        
        const buttonUrl = $(this).attr('href');
        clearCart($, function(res, jqXHR) {
            window.location.href = buttonUrl;
        });

    });

}



/**
 * Arrrow navigation in modals
 * @param {jQuery} $ 
 */
function modalScreensInit($) {

    const $screenTriggers = $('.js-screen-trigger');
    const $modalScreens = $('.js-modal-screen');

    $screenTriggers.on('click', function(e) {

        const $screenTrigger = $(this);

        if ($screenTrigger.is('a'))
            e.preventDefault();

        $modalScreens.removeClass('active');

        const target = $screenTrigger.data('screen');
        $( '.js-' + target ).addClass('active');
        
    });

}


/**
 * Set the delivery type in cookie base on data-screen attribute
 * @param {jQuery} $ 
 * @param {Object} userFilter 
 */
function ctaDeliveryChoicesInit($, userFilter) {

    const $deliveryChoice = $('.js-cta-delivery-choice');

    $deliveryChoice.on('click', function() {

        userFilter.deliveryType = $(this).data('screen');
        setCookieKeys( data = userFilter );

    });

}


/**
 * Display modal on click trigger and set attributes for filter
 * @param {jQuery} $ 
 * @param {Object} $body 
 * @param {Object} $modalCatalogTrigger 
 * @param {Object} $modalCatalog 
 */
function modalCatalogInit($, $body, $modalCatalogTrigger, $modalCatalog, userFilter) {

    const $modalCatalogClose = $('.js-modal-catalog-close');
    const $submitBtn = $modalCatalog.find('.js-submit');
    const $datepicker = $modalCatalog.find('.datepicker');
    let redirect = '';

    $modalCatalogClose.on('click', function(e) {
        $body.removeClass('modal-catalog-active');
    });

    $modalCatalogTrigger.on('click', function(e) {

        e.preventDefault();

        redirect = $(this).data('redirect');
        const minDate = $(this).data('min');
        const productType = $(this).data('cat');

        userFilter.productType = productType;
        setCookieKeys( data = userFilter );

        if ( productType == 'meals' ) {
            $body.addClass('modal-catalog-meals');
        }
        else {
            $body.removeClass('modal-catalog-meals');
        }

        if ( redirect ) {
            $submitBtn.attr('href', redirect);
        }
        else {
            $submitBtn.attr('href', window.location.href);
        }
        
        if ( minDate ) {
            $datepicker.attr('data-min', minDate);
            $datepicker.datepicker( "option", "minDate", minDate );
        }

        $body.addClass('modal-catalog-active');

    });

    $submitBtn.on('click', function(e) {
        e.preventDefault();
        clearCart($, function(res, jqXHR) {
            window.location.href = redirect;
        });
    });

}


/**
 * Set cookie used to filter catalog and delivery options
 * @param {JQuery} $ 
 * @param {Object} userFilter 
 * @param {Object} $datePickers 
 * @param {Object} $timeSlotsPickers
 * @param {Object} $datePickers
 */
function catalogFiltersInit($, userFilter, $datePickers ) {

    const $filter = $('.js-filter');
    const $locationChoices = $filter.find('.js-location');
    const $deliveryChoices = $filter.find('.js-delivery-type');

    $datePickers.on("change", function(e) {

        const $datePicker = $(this);
        let userFilterDate = $datePicker.datepicker('getDate');
        setDeliveryDate(userFilter, userFilterDate);

    });

    $locationChoices.on('change', function() {

        const $selected = $(this).find(':checked');
        userFilter.locationId = $selected.val();
        setCookieKeys( data = userFilter );

    });

    $deliveryChoices.on('change', function() {

        const $selected = $(this).find(':checked');
        userFilter.deliveryType = $selected.val();
        setCookieKeys( data = userFilter );

    });


}

/*-----------------------------------------------------------------------------------------*/
/* Functions */
/*-----------------------------------------------------------------------------------------*/

/**
 * Set delivery date in cookie and userFilter
 * @param {Object} userFilter 
 * @param {*} date Date string or object
 */
function setDeliveryDate(userFilter, date) {

    const startOfWeek = moment().startOf('isoWeek');
    const endOfWeek = moment().endOf('isoWeek');

    userFilter.date = moment(date).format('YYYY-MM-DD');
    userFilter.day = moment(date).format('dddd');
    userFilter.week = moment(date).isBetween(startOfWeek, endOfWeek) ? 'current' : 'next';

    setCookieKeys( data = userFilter );

}

/**
 * Remove not available time slots from timeslotspickers based on set threshold
 * @param {jQuery} $ 
 * @param {Object} $timeSlotsPickers 
 * @param {*} date Date string or object
 * @param {string} timeSlot
 */
function setAvailableTimeSlots($, userFilter, $timeSlotsPickers, date, timeSlot = '') {

    /* Brace yourself, the Nightmare begins ! */

    const isSameDay = moment(date).isSame(moment(), 'day');

    if ( !isSameDay && timeSlot.length ) {
        $timeSlotsPickers.each(function() {
            setSelectedTimeSlot($(this), timeSlot);
        });
    }
    else if (isSameDay) {

        const currentTime = moment().format('HH:mm');

        $timeSlotsPickers.each(function() {

            const $this = $(this);
            const $timeSlots = $this.find('.js-timeslot');

            $timeSlots.each(function() {
                
                const $this = $(this);
                const threshold = $this.data('threshold');
                if (currentTime >= threshold) {
                    $this.remove();
                }

            });
            
            if (timeSlot.length) {
                setSelectedTimeSlot($this, timeSlot)
            }
            else {
                setTimeSlot($this);
            }
            const timeSlotsCount = $this.find('.js-timeslot').length;
            if (timeSlotsCount == 0) {
                $timeSlotsPickers.replaceWith('<p class="closure-notice">'+localizedData.closureNotice+'</p>');
            }

        });

    }

    function setSelectedTimeSlot($timeSlotsPicker, timeSlot) {
        const $timeSlots = $timeSlotsPicker.find('.js-timeslot');
        const $selectedSlot = $timeSlots.filter('[value="'+timeSlot+'"]');
        if ($selectedSlot.length) {
            $selectedSlot.attr('selected', true);
        }
        else {
            setTimeSlot($timeSlotsPicker);
        }
    }

    function setTimeSlot($timeSlotsPicker) {
        const $selected = $timeSlotsPicker.find(':selected');
        if ($selected.length) {
            userFilter.timeSlot = $selected.val();
            setCookieKeys( userFilter );
        }
    }
    
}

/**
 * Remove not available time slots from timepickers based on set preparation time
 * @param {jQuery} $ 
 * @param {Object} $timePickers 
 * @param {*} date Date string or object
 * @param {string} time
 */
function setAvailableTime($, userFilter, $timePickers, date, time = '') {

    /* Return of the Nightmare */

    const currentDate = moment();
    const isSameDay = moment(date).isSame(currentDate, 'day');

    if ( !isSameDay && time.length ) {
        $timePickers.each(function() {
            const $this = $(this);
            const $hourPicker = $this.find('.js-timepicker-h');
            const $minutePicker = $this.find('.js-timepicker-m');
            const serviceEnd = $this.data('end');
            console.log(serviceEnd);
            setSelectedTime($hourPicker, $minutePicker, time);
        });
    }
    else if ( isSameDay ) {

        $timePickers.each(function() {

            const $this = $(this);
            const serviceEnd = $this.data('end');
            const currentTime = moment().format('HH:mm');
            if (currentTime >= serviceEnd) {
                $timePickers.replaceWith('<p class="closure-notice">'+localizedData.closureNotice+'</p>');
                return;
            }

            const preparationTime = moment.duration($this.data('preparation'), 'minutes');
            const $hourPicker = $this.find('.js-timepicker-h');
            const $hours = $hourPicker.find('.js-hour');
            const minTime = currentDate.add(preparationTime);
            const minMinutes = (minTime.format('mm') > 45) ? '00' : minTime.format('mm');
            const minHour = (minTime.format('mm') > 45) ? minTime.add(moment.duration('1', 'hour')).format('HH') : minTime.format('HH');
            const $minutePicker = $this.find('.js-timepicker-m');
            let $minutes = $minutePicker.find('.js-minutes');
            const $minutesClone = $minutes.clone();
            let hourSelected = '';

            /* INIT set available hours and minutes, set first available option in cookie */
            /* CA DECONNE ICI */
            //removeUnavailableOptions($hours, minHour);
            hourSelected = $hourPicker.val();
            console.log('selected:');
            console.log(hourSelected);
            console.log('minHour:');
            console.log(minHour);
            if (hourSelected == minHour) {
                removeUnavailableOptions($minutes, minMinutes);
            }

            if (time.length) {
                setSelectedTime($hourPicker, $minutePicker, time);
            }
            else {
                setTime($hourPicker, $minutePicker);
            }

            /* on hour select filter minutes */

            $hourPicker.on('click', function() {

                setTime($hourPicker, $minutePicker);

                hourSelected = $(this).val();

                if (hourSelected == minHour) {
                    removeUnavailableOptions($minutes, minMinutes);
                }
                else {
                    $minutePicker.empty();
                    $minutesClone.appendTo($minutePicker);
                    $minutes = $minutePicker.find('.js-minutes');
                }
            });

            $minutePicker.on('click', function() {

                setTime($hourPicker, $minutePicker);
                
            });

        });

    }

    function setSelectedTime($hourPicker, $minutePicker, time) {
        
        const timeArr = time.split(':');
        const chosenHour = timeArr[0];
        const chosenMin = timeArr[1];

        const $hours = $hourPicker.find('.js-hour');
        const $selectedHour = $hours.filter('[value="'+chosenHour+'"]');
        const $minutes = $minutePicker.find('.js-minutes');
        const $selectedMinute = $minutes.filter('[value="'+chosenMin+'"]');
        if ($selectedHour.length && $selectedMinute.length) {
            $selectedHour.attr('selected', true);
            $selectedMinute.attr('selected', true);
        }
        else {
            setTime($hourPicker, $minutePicker);
        }
    }

    function removeUnavailableOptions($option, minTime) {
        $option.each(function() {
            const $option = $(this);
            if ($option.val() < minTime) {
                $option.remove();
            }
        });
    }

    function setTime($hourPicker, $minutePicker) {
        const $hour = $hourPicker.find(':selected');
        const $min = $minutePicker.find(':selected');
        if ($hour.length && $min.length) {
            const hour = $hour.val();
            const min = $min.val();
            userFilter.time = hour + ':' + min;
            setCookieKeys( userFilter );
        }
    }

    
}

/**
 * Call ajax clear_cart then executes callback on success
 * @param {jQuery} $ 
 * @param {Function} callback
 */
function clearCart($, callback) {
    $.ajax({
        url: localizedData.adminUrl,
        type: "POST",
        cache: false,
        data: {
            action: 'callback_clear_cart'
        },
        success: function(res, textStatus, jqXHR) {
            if ( res.success == true )  {
                console.log('cleared!');
                //window.location.href = buttonUrl;
                if (callback) callback(res, jqXHR);
            }
            else {
                console.log(res) ;
            }
        }
    });
}